import GestionArchivosCV from "./controladorVista/gestionArchivosCV";

export const GestionArchivos = () => {
  return <GestionArchivosCV />;
};

export default GestionArchivos;
